import React from "react";
import {
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
} from "./index";

interface DataTableProps extends React.ComponentProps<typeof Table> {
  headers: string[];
  data: Array<{ [key: string]: any }>;
}

const DataTable = ({ headers, data, ...props }: DataTableProps) => {
  return (
    <Table {...props}>
      <TableHeader>
        <TableRow>
          {headers.map((header, index) => (
            <TableHead key={index}>{header}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {headers.map((header, cellIndex) => (
              <TableCell key={cellIndex} data-label={header}>{row[header]}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export { DataTable };
